import customFetch from '../../utils/customFetch'
import { API_ENDPOINT } from '../../config'
import { ManualGeoLoadResult } from '../../@types/types'
import { geoManualHierarchyResultsToApp } from './converters/hierarchyResult'

export const loadCities: (countryId: string, regionId: string) => ManualGeoLoadResult = async (countryId, regionId) => {
  const options = {
    method: 'GET',
    headers: {
      Accept: 'application/json; charset=utf-8',
      'Content-Type': 'application/json; charset=UTF-8',
    },
    credentials: 'include',
  }

  const url = `${API_ENDPOINT}/anbieten/private-anbieter/inserieren/api/geo/manual/countries/${countryId}/${regionId}/`
  const response = await customFetch(url, options)
  return geoManualHierarchyResultsToApp(await response.json())
}

export const loadQuarters: (countryId: string, regionId: string, quarterId: string) => ManualGeoLoadResult = async (
  countryId,
  regionId,
  quarterId
) => {
  const options = {
    method: 'GET',
    headers: {
      Accept: 'application/json; charset=utf-8',
      'Content-Type': 'application/json; charset=UTF-8',
    },
    credentials: 'include',
  }

  const url = `${API_ENDPOINT}/anbieten/private-anbieter/inserieren/api/geo/manual/countries/${countryId}/${regionId}/${quarterId}/`
  const response = await customFetch(url, options)
  return geoManualHierarchyResultsToApp(await response.json())
}

export const loadRegions: (countryId: string) => ManualGeoLoadResult = async (countryId: string) => {
  const options = {
    method: 'GET',
    headers: {
      Accept: 'application/json; charset=utf-8',
      'Content-Type': 'application/json; charset=UTF-8',
    },
    credentials: 'include',
  }

  const url = `${API_ENDPOINT}/anbieten/private-anbieter/inserieren/api/geo/manual/countries/${countryId}/`
  const response = await customFetch(url, options)
  return geoManualHierarchyResultsToApp(await response.json())
}

export const loadCountries: () => ManualGeoLoadResult = async () => {
  const options = {
    method: 'GET',
    headers: {
      Accept: 'application/json; charset=utf-8',
      'Content-Type': 'application/json; charset=UTF-8',
    },
    credentials: 'include',
  }

  const url = `${API_ENDPOINT}/anbieten/private-anbieter/inserieren/api/geo/manual/countries/`
  const response = await customFetch(url, options)
  return geoManualHierarchyResultsToApp(await response.json())
}
